import script from "./GoodsItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./GoodsItem.vue?vue&type=script&lang=ts&setup=true"

import "./GoodsItem.vue?vue&type=style&index=0&id=1fc52cf8&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fc52cf8"]])

export default __exports__